import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import Favorite from '@material-ui/icons/Favorite';
import Description from '@material-ui/icons/Description';
import Class from '@material-ui/icons/Class';
import Button from 'components/CustomButtons/Button.jsx';
import CloudDownload from '@material-ui/icons/CloudDownload';
import { CSVLink } from "react-csv";

let counter = 0;
let ansCounter = 0;
// function createData(name, calories, fat, carbs, protein) {
//   counter += 1;
//   return { id: counter, name, calories, fat, carbs, protein };
// }




function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}


class EnhancedTableHead extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    // createData(examName, number, answerRate, updateTime, datakey) {
    //     counter += 1;
    //     return { id: counter, examName, number, answerRate, updateTime, datakey };
    // }

    getRow(examlist, datakey) {
        var rowData = [];
        if (examlist.length > 0 && datakey) {
            rowData.push({ id: 'student', numeric: false, disablePadding: true, label: '座號' });
            rowData.push({ id: 'answerRate', numeric: false, disablePadding: false, label: '答對率' });
            var checkExamNumber = examlist.findIndex(img => img.key === datakey);
            var exdata = examlist[checkExamNumber];
            var ansTxt = exdata.value.correctAns;;
            var ans = ansTxt.split(',');
            //移除班級
            //for (let index = 3; index < ans.length; index++) {
            // var title = (index - 2);
            // var dataIndex = "ans" + (index - 2);
            for (let index = 0; index < ans.length; index++) {
                var title = (index + 1);
                var dataIndex = "ans" + (index + 1);

                rowData.push({ id: dataIndex, numeric: false, disablePadding: false, label: title })
            }
        }


        return rowData;
    }


    render() {
        const { onSelectAllClick, order, orderBy, numSelected, rowCount, dataType } = this.props;

        const rows = this.getRow(dataType.userGetReportsData, dataType.classResultID)

        return (

            <TableHead>
                <TableRow>
                    {/* <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount}
              onChange={onSelectAllClick}
            />
          </TableCell> */}
                    {rows.map(
                        row => (
                            <TableCell
                                key={row.id}
                                align={row.numeric ? 'right' : 'left'}
                                padding={row.disablePadding ? 'none' : 'default'}
                                sortDirection={orderBy === row.id ? order : false}
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id)}
                                    >
                                        {row.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        ),
                        this,
                    )}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit,
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: theme.palette.text.secondary,
    },
    title: {
        flex: '0 0 auto',
    },
});

let EnhancedTableToolbar = props => {
    const { numSelected, classes } = props;

    return (
        <Toolbar
            className={classNames(classes.root, {
                [classes.highlight]: numSelected > 0,
            })}
        >
            <div className={classes.title}>
                {numSelected > 0 ? (
                    <Typography color="inherit" variant="subtitle1">
                        {numSelected} selected
                    </Typography>
                ) : (
                        <Typography variant="h6" id="tableTitle">
                            Nutrition
                        </Typography>
                    )}
            </div>
            <div className={classes.spacer} />
            <div className={classes.actions}>
                {numSelected > 0 ? (
                    <Tooltip title="Delete">
                        <IconButton aria-label="Delete">
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                ) : (
                        ""
                        // <Tooltip title="Filter list">
                        //   <IconButton aria-label="Filter list">
                        //     <FilterListIcon />
                        //   </IconButton>
                        // </Tooltip>
                    )}
            </div>
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 1020,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
});

class EnhancedTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            order: 'asc',
            orderBy: 'student',
            selected: [],
            data: [],
            page: 0,
            rowsPerPage: 5,
            dataType: props.dataType,
        };

    }


    createData(student, answerRate, data) {
        counter += 1;

        // return { id: counter, student, answerRate, ans: this.createAnsData(data) };
        var obj = { id: counter, student, answerRate };
        for (let index = 0; index < data.length; index++) {
            obj["ans" + (index + 1)] = data[index];
        }
        return obj;
    }

    createAnsData(data) {

        var ansData = [];
        for (let index = 0; index < data.length; index++) {
            ansData.push({ id: ansCounter, ans: data[index] });
            ansCounter += 1;

        }

        return ansData;
    }

    getData(examlist, datakey, groupName) {
        var testData = [];
        if (examlist.length > 0 && datakey) {



            var checkExamNumber = examlist.findIndex(img => img.key === datakey);


            if (checkExamNumber > -1) {
                var exdata = examlist[checkExamNumber];


                // for (let i = 0; i < exdata.length; i++) {
                //var newData = [];
                // var studentsNumber = 0;
                var getAnswer = 0;
                var getStudensAns = 0;
                var getAnswerRate = 0;

                if (exdata.value.students) {
                    var ansTxt = exdata.value.correctAns;
                    var ans = ansTxt.split(',');
                    // var exstudents = exdata.value.students;
                    //var exstudents = exdata.value.students;

                    var students = {};
                    Object.keys(exdata.value.students).map(function (objectKey, index) {
                        var value = exdata.value.students[objectKey];
                        var groupNameData = groupName.split('-');
                        if ((value.gradeNo).toString() == groupNameData[0] && (value.classNo).toString() == groupNameData[1]) {
                            students[objectKey] = value;
                        }
                    });


                    // studentsNumber = (Object.keys(students)).length;
                    //移除班級
                    //getAnswer = (ans.length - 3) * studentsNumber;
                    // getAnswer = (ans.length ) * studentsNumber;
                    getAnswer = ans.length;
                    //前三個為班級等資訊
                    for (var getstudents in students) {
                        getStudensAns = 0;
                        var studentAnsTxt = students[getstudents].ans;
                        // students[getstudents]
                        var studentAns = studentAnsTxt.split(',');
                        var ansData = [];
                        //移除班級
                        //for (let index = 3; index < ans.length; index++) {
                        for (let index = 0; index < ans.length; index++) {
                            const a = ans[index];
                            const s = studentAns[index];
                            if (a === s) {
                                getStudensAns++;
                            }
                            // ansData.push
                        }
                        getAnswerRate = getStudensAns / getAnswer;
                        getAnswerRate = (Math.round(getAnswerRate * 10000) / 100).toFixed(2) + '%';
                        // studentAns.shift();
                        // studentAns.shift();
                        // studentAns.shift();


                        // testData.push(this.createData(getstudents, getAnswerRate, studentAns));
                        //改成顯示座號 
                        //testData.push(this.createData(getstudents, getAnswerRate, studentAns));
                        var studentNo = students[getstudents].no;
                        testData.push(this.createData(studentNo, getAnswerRate, studentAns));
                    }
                }

                // }
            }
        }
        return testData;
    }




    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleSelectAllClick = event => {
        if (event.target.checked) {
            this.setState(state => ({ selected: state.data.map(n => n.id) }));
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, id) => {
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({ selected: newSelected });
    };
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    isSelected = id => this.state.selected.indexOf(id) !== -1;


    render() {
        const { classes, dataType, tableBtnToTabData, selectTableTab, tableBtnClassResult } = this.props;
        var data = this.getData(dataType.userGetReportsData, dataType.classResultID, dataType.answerAnalysisID);


        data.sort((a, b) => {

            if (a.student < b.student) {

                return -1;
            } else {

                return 1;
            }

        });


        function getHeader(examlist, datakey, groupName) {
            var head = [];
            head.push({ label: "座號", key: "student" });
            head.push({ label: "答對率", key: "answerRate" });
            if (examlist.length > 0 && datakey) {
                var checkExamNumber = examlist.findIndex(img => img.key === datakey);
                if (checkExamNumber > -1) {
                    var exdata = examlist[checkExamNumber];
                    var ex = exdata["value"].correctAns.split(',');

                    //移除班級
                    //    for (let index = 3; index < ex.length; index++) {
                    //         var title = (index - 2);
                    //         var dataIndex = "ans" + (index - 2);
                    //移除班級
                    for (let index = 0; index < ex.length; index++) {
                        var title = (index + 1);
                        var dataIndex = "ans" + (index + 1);
                        head.push({ label: title, key: dataIndex });

                    }

                }
            }
            return head;
        }



        var headers = getHeader(dataType.userGetReportsData, dataType.classResultID, dataType.answerAnalysisID);

        // function getHeader(data) {
        //     var head = [];
        //     head.push({ label: "座號", key: "student" });
        //     head.push({ label: "答對率", key: "answerRate" });

        //     for (let index = 3; index < data.length; index++) {

        //         var title = (index - 2);
        //         var dataIndex = "ans" + (index - 2);
        //         head.push({ label: title, key: dataIndex });

        //     }
        //     return head;
        // }

        //var headers = getHeader(dataType.userGetReportsData, dataType.classResultID, dataType.answerAnalysisID);

        // const { data, order, orderBy, selected, rowsPerPage, page } = this.state;
        const { order, orderBy, selected, rowsPerPage, page } = this.state;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);


        function handleBtnToNaniExaminationPaperAnalysisClick(event) {

            var navigations = [true, true, false, false]
            var datakey = "";
            if (event.target.getAttribute("datakey")) {
                datakey = event.target.getAttribute("datakey")
            }
            if (event.target.parentElement.getAttribute("datakey")) {
                datakey = event.target.parentElement.getAttribute("datakey")
            }
            if (event.target.parentElement.parentElement.getAttribute("datakey")) {
                datakey = event.target.parentElement.parentElement.getAttribute("datakey")
            }
            if (event.target.parentElement.parentElement.parentElement.getAttribute("datakey")) {
                datakey = event.target.parentElement.parentElement.parentElement.getAttribute("datakey")
            }
            if (datakey != "") {
                tableBtnToTabData(navigations, 1, datakey);
            }
        }


        function handleeeClick(event) {
            //selectTableTab(1);
        }

        function GetNowTime() {
            var timeDate = new Date();
            var tMonth = (timeDate.getMonth() + 1) > 9 ? (timeDate.getMonth() + 1) : '0' + (timeDate.getMonth() + 1);
            var tDate = timeDate.getDate() > 9 ? timeDate.getDate() : '0' + timeDate.getDate();
            var tHours = timeDate.getHours() > 9 ? timeDate.getHours() : '0' + timeDate.getHours();
            var tMinutes = timeDate.getMinutes() > 9 ? timeDate.getMinutes() : '0' + timeDate.getMinutes();
            var tSeconds = timeDate.getSeconds() > 9 ? timeDate.getSeconds() : '0' + timeDate.getSeconds();
            // return timeDate= timeDate.getFullYear()+'/'+ tMonth +'/'+ tDate +' '+ tHours +':'+ tMinutes +':'+ tSeconds;
            return timeDate = timeDate.getFullYear() + tMonth + tDate + tHours + tMinutes + tSeconds;
        }

        function handBtnClassResultClick(event) {
            var navigations = [true, false, true, false]
            var datakey = "";
            if (event.target.getAttribute("datakey")) {
                datakey = event.target.getAttribute("datakey")
            }
            if (event.target.parentElement.getAttribute("datakey")) {
                datakey = event.target.parentElement.getAttribute("datakey")
            }
            if (event.target.parentElement.parentElement.getAttribute("datakey")) {
                datakey = event.target.parentElement.parentElement.getAttribute("datakey")
            }
            if (event.target.parentElement.parentElement.parentElement.getAttribute("datakey")) {
                datakey = event.target.parentElement.parentElement.parentElement.getAttribute("datakey")
            }
            if (datakey != "") {
                tableBtnClassResult(navigations, 2, datakey);
            }
        }

        return (

            <Paper className={classes.root}>
                <Toolbar className={classNames(classes.root)}        >
                    <div className={classes.actions}>
                        <CSVLink data={data} headers={headers} filename={"學生成績" + GetNowTime() + ".csv"}>
                            {/* <CloudDownload />報表下載 */}
                            <Button size="sm" color="primary"><i class="fas fa-cloud-download-alt"></i>報表下載</Button>
                        </CSVLink>
                    </div>
                </Toolbar>
                {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
                <div className={classes.tableWrapper}>
                    <Table className={classes.table} aria-labelledby="tableTitle" fixedHeader={false} style={{ width: "auto", tableLayout: "auto", minWidth: (dataType.isMobile ? "800px" : "1020px") }} >
                        <EnhancedTableHead
                            dataType={dataType}
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={this.handleSelectAllClick}
                            onRequestSort={this.handleRequestSort}
                            rowCount={data.length}
                        />
                        <TableBody>
                            {stableSort(data, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(n => {
                                    const isSelected = this.isSelected(n.id);
                                    return (
                                        <TableRow
                                            hover
                                            onClick={event => this.handleClick(event, n.id)}
                                            role="checkbox"
                                            aria-checked={isSelected}
                                            tabIndex={-1}
                                            key={n.id}
                                            selected={isSelected}
                                        >
                                            <TableCell component="th" scope="row" padding="none">
                                                {n.student}
                                            </TableCell>
                                            <TableCell align="right">{n.answerRate}</TableCell>

                                            {
                                                Object.keys(n).map(ans => {
                                                    return (
                                                        (ans == "student" || ans == "answerRate" || ans == "id") ? "" : <TableCell align="right">{n[ans]}</TableCell>)
                                                }

                                                )

                                            }
                                        </TableRow>
                                    );
                                })}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 49 * emptyRows }}>
                                    <TableCell colSpan={4} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </div>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    labelRowsPerPage="筆數"
                    labelDisplayedRows={({ from, to, count }) => ` ${from}-${to} 總數 ${count} `}
                    backIconButtonProps={{
                        'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Next Page',
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
            </Paper>
        );
    }
}

EnhancedTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EnhancedTable);


// WEBPACK FOOTER //
// ./src/views/NaniAnswerAnalysis/NaniAnswerAnalysis.js